import moment from 'moment';

export const formatDate = (date: any) => {
  const returnDate = moment(date).format('MM/DD/YYYY');
  return returnDate;
};
